import { render, staticRenderFns } from "./BiddingBuyNowButton.vue?vue&type=template&id=58427b28&scoped=true"
import script from "./BiddingBuyNowButton.vue?vue&type=script&lang=js"
export * from "./BiddingBuyNowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58427b28",
  null
  
)

export default component.exports